module.exports = __webpack_public_path__ + "img/tex_dt01.56acf197.svg";